import React from 'react';
import { HashLink } from 'react-router-hash-link';

const NavLinks = ({ mobile = false, setIsOpen }) => {
    const handleLinkClick = () => {
        if (mobile && setIsOpen) {
            setIsOpen(false);
        }
    };

    const linkClasses = mobile
        ? "w-full py-2.5 px-4 font-medium text-slate-700 hover:text-cyan-600 hover:bg-slate-50 rounded-xl transition duration-200 block text-left"
        : "px-5 py-2 font-medium text-slate-600 hover:text-cyan-600 transition-colors duration-200 rounded-lg hover:bg-slate-50/50";

    return (
        <>
            <HashLink
                className={linkClasses}
                smooth
                to="/#intro"
                onClick={handleLinkClick}
            >
                About Us
            </HashLink>
            <HashLink
                className={linkClasses}
                smooth
                to="/#services"
                onClick={handleLinkClick}
            >
                Services
            </HashLink>
            <HashLink
                className={linkClasses}
                to="/sme"
                onClick={handleLinkClick}
            >
                SME
            </HashLink>
            {mobile ? (
                <HashLink
                    className="w-full py-2.5 px-4 text-center font-semibold text-white bg-gradient-to-r from-cyan-500 to-blue-600 rounded-xl shadow-md shadow-cyan-500/10 block hover:from-cyan-600 hover:to-blue-700 transition-all duration-200"
                    to="/contact"
                    onClick={handleLinkClick}
                >
                    Contact Us
                </HashLink>
            ) : (
                <HashLink
                    className="ml-4 px-5 py-2 font-semibold text-white bg-cyan-600 hover:bg-cyan-700 transition duration-200 rounded-xl shadow-md shadow-cyan-600/10 hover:shadow-cyan-600/20 block hover:-translate-y-0.5 transform"
                    to="/contact"
                >
                    Contact Us
                </HashLink>
            )}
        </>
    );
};

export default NavLinks;
